import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default class Main {
    
    constructor() {
        this._init();
    }

    _init(){
        gsap.registerPlugin(ScrollToPlugin);
        gsap.registerPlugin(ScrollTrigger);

        this._acc();
        this._scrollNav();
    }


    _acc(){

        [...document.querySelectorAll('.js-acc')].forEach($acc => {
            const $trigger = $acc.querySelector('dt');
            $trigger.addEventListener('click', ()=>{
                $acc.classList.toggle('-active');
            });
        });
    }


    _scrollNav(){
        const footer = document.querySelector(".l-footer");
        const nav = document.querySelector(".l-nav");

        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };

        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    nav.classList.remove("-active");
                } else {
                    nav.classList.add("-active");
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(footer);
    }
}
